import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface RadioQuestionProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export const RadioQuestion = ({ options, value, onChange }: RadioQuestionProps) => {
  return (
    <RadioGroup onValueChange={onChange} value={value} className="space-y-3">
      {options.map((option) => (
        <div key={option} className="flex items-center space-x-2">
          <RadioGroupItem 
            value={option} 
            id={option} 
            className="border-green-500 text-green-500 data-[state=checked]:bg-green-500 data-[state=checked]:text-white" 
          />
          <Label htmlFor={option} className="text-foreground">{option}</Label>
        </div>
      ))}
    </RadioGroup>
  );
};